//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ConfigurationsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5056";

    }

    list(  cancelToken?: CancelToken | undefined): Promise<ConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/Configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConfigurationDto[]>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationDto[]>(null as any);
    }

    create(command: CreateConfigurationCommand , cancelToken?: CancelToken | undefined): Promise<ConfigurationDto> {
        let url_ = this.baseUrl + "/api/Configurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ConfigurationDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationDto>(null as any);
    }

    get(configurationId: string | null , cancelToken?: CancelToken | undefined): Promise<ConfigurationDto> {
        let url_ = this.baseUrl + "/api/Configurations/{configurationId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConfigurationDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationDto>(null as any);
    }

    getExisting(form: ConfigurationForm , cancelToken?: CancelToken | undefined): Promise<ConfigurationDto> {
        let url_ = this.baseUrl + "/api/Configurations/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExisting(_response);
        });
    }

    protected processGetExisting(response: AxiosResponse): Promise<ConfigurationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ConfigurationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationDto>(null as any);
    }

    updatePowerUsage(configurationId: string | null, command: UpdatePowerUsageCommand , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Configurations/{configurationId}/powerusage";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePowerUsage(_response);
        });
    }

    protected processUpdatePowerUsage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateInstallation(configurationId: string | null, command: UpdateInstallationCommand , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Configurations/{configurationId}/customertype";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInstallation(_response);
        });
    }

    protected processUpdateInstallation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateInstallationDetails(configurationId: string | null, command: UpdateInstallationDetailsCommand , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Configurations/{configurationId}/installationdetails";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInstallationDetails(_response);
        });
    }

    protected processUpdateInstallationDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PanelsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5056";

    }

    get(panelSku: string | null , cancelToken?: CancelToken | undefined): Promise<PanelDto> {
        let url_ = this.baseUrl + "/api/Panels/panel/{panelSku}";
        if (panelSku === undefined || panelSku === null)
            throw new Error("The parameter 'panelSku' must be defined.");
        url_ = url_.replace("{panelSku}", encodeURIComponent("" + panelSku));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PanelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PanelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PanelDto>(null as any);
    }

    getAll(brand?: string | null | undefined, mountType?: MountType | null | undefined , cancelToken?: CancelToken | undefined): Promise<PanelDto[]> {
        let url_ = this.baseUrl + "/api/Panels?";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (mountType !== undefined && mountType !== null)
            url_ += "mountType=" + encodeURIComponent("" + mountType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PanelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PanelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PanelDto[]>(null as any);
    }

    getBrands(  cancelToken?: CancelToken | undefined): Promise<PanelBrandDto[]> {
        let url_ = this.baseUrl + "/api/Panels/brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrands(_response);
        });
    }

    protected processGetBrands(response: AxiosResponse): Promise<PanelBrandDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PanelBrandDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PanelBrandDto[]>(null as any);
    }
}

export class RoofsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5056";

    }

    create(configurationId: string | null, command: CreateRoofCommand , cancelToken?: CancelToken | undefined): Promise<RoofId> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RoofId> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<RoofId>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoofId>(null as any);
    }

    list(configurationId: string | null , cancelToken?: CancelToken | undefined): Promise<RoofDto[]> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<RoofDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoofDto[]>(result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoofDto[]>(null as any);
    }

    get(configurationId: string | null, roofId: string | null , cancelToken?: CancelToken | undefined): Promise<RoofDto> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}/{roofId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (roofId === undefined || roofId === null)
            throw new Error("The parameter 'roofId' must be defined.");
        url_ = url_.replace("{roofId}", encodeURIComponent("" + roofId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RoofDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoofDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoofDto>(null as any);
    }

    update(configurationId: string | null, roofId: string | null, command: UpdateRoofCommand , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}/{roofId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (roofId === undefined || roofId === null)
            throw new Error("The parameter 'roofId' must be defined.");
        url_ = url_.replace("{roofId}", encodeURIComponent("" + roofId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(configurationId: string | null, roofId: string | null, command: DeleteRoofCommand , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}/{roofId}";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (roofId === undefined || roofId === null)
            throw new Error("The parameter 'roofId' must be defined.");
        url_ = url_.replace("{roofId}", encodeURIComponent("" + roofId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePanel(configurationId: string | null, roofId: string | null, command: UpdateRoofPanelCommand , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}/{roofId}/panel";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (roofId === undefined || roofId === null)
            throw new Error("The parameter 'roofId' must be defined.");
        url_ = url_.replace("{roofId}", encodeURIComponent("" + roofId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePanel(_response);
        });
    }

    protected processUpdatePanel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updatePanelGrid(configurationId: string | null, roofId: string | null, command: UpdateRoofPanelGridCommand , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}/{roofId}/panelgrid";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (roofId === undefined || roofId === null)
            throw new Error("The parameter 'roofId' must be defined.");
        url_ = url_.replace("{roofId}", encodeURIComponent("" + roofId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePanelGrid(_response);
        });
    }

    protected processUpdatePanelGrid(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updatePanelGridOrientation(configurationId: string | null, roofId: string | null, command: UpdateRoofPanelGridOrientationCommand , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Roofs/{configurationId}/{roofId}/panelgridorientation";
        if (configurationId === undefined || configurationId === null)
            throw new Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        if (roofId === undefined || roofId === null)
            throw new Error("The parameter 'roofId' must be defined.");
        url_ = url_.replace("{roofId}", encodeURIComponent("" + roofId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePanelGridOrientation(_response);
        });
    }

    protected processUpdatePanelGridOrientation(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ApiService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5056";

    }

    get(contentItemId: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/content/{contentItemId}";
        if (contentItemId === undefined || contentItemId === null)
            throw new Error("The parameter 'contentItemId' must be defined.");
        url_ = url_.replace("{contentItemId}", encodeURIComponent("" + contentItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(contentItemId: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/content/{contentItemId}";
        if (contentItemId === undefined || contentItemId === null)
            throw new Error("The parameter 'contentItemId' must be defined.");
        url_ = url_.replace("{contentItemId}", encodeURIComponent("" + contentItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    post(model: ContentItem, draft?: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/content?";
        if (draft === null)
            throw new Error("The parameter 'draft' cannot be null.");
        else if (draft !== undefined)
            url_ += "draft=" + encodeURIComponent("" + draft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface EntityDtoOfString {
    entityId: string;
}

export interface ConfigurationDto extends EntityDtoOfString {
    installation: InstallationDto;
    powerUsage?: PowerUsageDto | undefined;
    panelAndMountingCost?: number;
    energyStorageSolution?: EnergyStorageSolutionDto | undefined;
    roofs?: RoofDto[] | undefined;
    installationDetails?: InstallationDetailsDto | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    postcode?: string | undefined;
    quoteReferenceNumber?: string | undefined;
}

export interface InstallationDto {
    installationType: InstallationType;
    powerSupplyType: PowerSupplyType;
}

export enum InstallationType {
    Domestic = 10,
    Commercial = 20,
    Offgrid = 30,
    Agricultural = 40,
}

export enum PowerSupplyType {
    SinglePhase = 10,
    ThreePhase = 20,
    DontKnow = 30,
}

export interface PowerUsageDto {
    kiloWatts?: number;
    timePeriod: TimePeriod;
    monthlyElectricityBill: number;
}

export enum TimePeriod {
    Annual = 10,
    Monthly = 20,
    Quarterly = 30,
}

export interface EnergyStorageSolutionDto {
    name?: string | undefined;
    deliveryCost?: number;
    remoteConfigurationCost?: number;
    installationCost?: number;
    pricePerBattery?: number;
    totalCost?: number;
    estimatedOutput?: number | undefined;
}

export interface UpdateRoofForm {
    name: string;
    heightInMetres: number;
    widthInMetres: number;
    mountType: MountType;
    roofType: RoofType;
}

export interface RoofDto extends UpdateRoofForm {
    roofId: string;
    panel?: PanelDto | undefined;
    panelStockMessage?: string | undefined;
    amountOfPanels?: number;
    panelGridRows?: PanelGridRowDto[] | undefined;
    panelOrientation?: RoofPanelGridOrientation | undefined;
    installedCapacity?: number;
    estimatedAnnualOutput?: number;
}

export interface PanelDto {
    brand?: string | undefined;
    product?: string | undefined;
    sku?: string | undefined;
    weight?: number;
    ratedPower?: number;
    height?: number;
    depth?: number;
    width?: number;
    efficiency?: string | undefined;
    price?: number;
    description?: string | undefined;
    panelStockStatus?: PanelStockStatus;
    dueInStockDate?: string | undefined;
    frameType?: PanelFrameType;
    mountType?: MountType | undefined;
}

export enum PanelStockStatus {
    InStock = 10,
    DueIn = 20,
    OutOfStock = 30,
}

export enum PanelFrameType {
    AllBlack = 10,
    BlackFrame = 20,
    SilverFrame = 30,
}

export enum MountType {
    OnRoof = 10,
    InRoof = 20,
    GroundMounting = 30,
    DontKnow = 40,
}

export interface UpdatePanelGridRowForm {
    slots: PanelGridSlotDto[];
}

export interface PanelGridRowDto extends UpdatePanelGridRowForm {
}

export interface PanelGridSlotDto {
    hasPanel?: boolean;
}

export enum RoofPanelGridOrientation {
    Portrait = 10,
    Landscape = 20,
}

export enum RoofType {
    Tile = 10,
    Slate = 20,
    Flat = 30,
    Corrugated = 40,
}

export interface UpdateInstallationDetailsForm {
    firstName: string;
    lastName: string;
    email: string;
    postcode: string;
    projectGoAhead: ProjectGoAhead;
    installer: boolean;
}

export interface InstallationDetailsDto extends UpdateInstallationDetailsForm {
}

export enum ProjectGoAhead {
    AsSoonAsPossible = 10,
    WithinSixMonths = 20,
    WithinTwelveMonths = 30,
    JustLookingAtMyOptions = 40,
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };
}

export interface ConfigurationForm {
    email: string;
    postcode: string;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors?: { [key: string]: string[]; };
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };
}

export interface AuditableCommandOfConfigurationAndConfigurationId {
}

export interface CreateConfigurationCommand extends AuditableCommandOfConfigurationAndConfigurationId {
    installationType: InstallationType;
    powerSupplyType: PowerSupplyType;
}

export interface UpdatePowerUsageForm extends PowerUsageDto {
}

export interface UpdatePowerUsageCommand extends UpdatePowerUsageForm {
}

export interface UpdateInstallationForm {
    installationType: InstallationType;
    powerSupplyType: PowerSupplyType;
}

export interface UpdateInstallationCommand extends UpdateInstallationForm {
}

export interface UpdateInstallationDetailsCommand extends UpdateInstallationDetailsForm {
}

export interface PanelBrandDto {
    name: string;
}

export interface ValueObject {
}

export interface ValueObjectOfRoofId extends ValueObject {
}

export interface EntityIdOfRoofId extends ValueObjectOfRoofId {
    value?: string;
}

export interface RoofId extends EntityIdOfRoofId {
}

export interface AddRoofDto {
    name: string;
    heightInMetres: number;
    widthInMetres: number;
    mountType: MountType;
    roofType: RoofType;
    panelSku?: string | undefined;
    panelOrientation?: RoofPanelGridOrientation;
}

export interface CreateRoofCommand extends AddRoofDto {
}

export interface UpdateRoofCommand {
    updateRoofForm: UpdateRoofForm;
}

export interface DeleteRoofCommand {
}

export interface UpdateRoofPanelForm {
    panelSku: string;
    panelOrientation: RoofPanelGridOrientation;
    mountType: MountType;
}

export interface UpdateRoofPanelCommand extends UpdateRoofPanelForm {
}

export interface UpdateRoofPanelGridCommand {
    panelGridRows: PanelGridRowDto[];
}

export interface UpdatePanelGridOrientationForm {
    panelOrientation: RoofPanelGridOrientation;
    mountType: MountType;
}

export interface UpdateRoofPanelGridOrientationCommand extends UpdatePanelGridOrientationForm {
}

/** Common traits of ContentItem, ContentPart and ContentField */
export interface ContentElement {
}

/** Represents a content item version. */
export interface ContentItem extends ContentElement {
    /** The primary key in the database. */
    id?: number;
    /** The logical identifier of the content item across versions. */
    contentItemId?: string | undefined;
    /** The logical identifier of the versioned content item. */
    contentItemVersionId?: string | undefined;
    /** The content type of the content item. */
    contentType?: string | undefined;
    /** Whether the version is published or not. */
    published?: boolean;
    /** Whether the version is the latest version of the content item. */
    latest?: boolean;
    /** When the content item version has been updated. */
    modifiedUtc?: string | undefined;
    /** When the content item has been published. */
    publishedUtc?: string | undefined;
    /** When the content item has been created or first published. */
    createdUtc?: string | undefined;
    /** The user id of the user who first created this content item version. */
    owner?: string | undefined;
    /** The name of the user who last modified this content item version. */
    author?: string | undefined;
    /** The text representing this content item. */
    displayText?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}